<div class="content">
    <div class="main-wrapper">
        <div class="booking-container">
            <div class="booking-table">
                <img src="assets/images/table-resevation.png">
            </div>
        </div>
    </div>
</div>